import {
  faAngleRight,
  faChevronDown,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { headerButtons, headerMenu } from '~/components/layout/Header/data';
import { useHeaderContext } from '~/components/layout/Header/HeaderContext';
import NavigationDropdownMenu from '~/components/layout/Header/Navigation/NavigationDropdownMenu';
import { Link } from '~/components/ui/Link';
import { pathName as pathname } from '~/helpers/projectConstant';
import { cn } from '~/helpers/utils';

const Index = () => {
  const { variant, openMenu, onMenuToggle, onMenuOpen, onMenuLeave } =
    useHeaderContext();

  const triggerClasses = (isOpen: boolean, isActive = false) =>
    cn(
      'h-20 flex items-center gap-1.5 border-y-4 border-transparent py-2 mx-3',
      'font-display text-sm font-medium transition-colors cursor-pointer no-outline no-underline',
      'outline-none focus-visible:ring-2 focus-visible:ring-blue-500',
      isOpen || isActive ? 'border-b-blue-500' : 'hover:border-b-blue-500',
      variant === 'light' &&
        (isOpen || isActive
          ? 'text-blue-600'
          : 'text-black hover:text-blue-600'),
      variant === 'dark' &&
        (isOpen || isActive
          ? 'text-blue-400'
          : 'text-white hover:text-blue-400')
    );

  return (
    <div className="hidden items-center gap-3 md:flex">
      <nav className="flex items-center gap-1" onMouseLeave={onMenuLeave}>
        {headerMenu.map((item) => {
          if ('subMenuType' in item && item.subMenuType === 'mega') {
            const isActive = item.subMenu.some((col) =>
              col.links.some((link) => pathname.startsWith(link.href))
            );

            return (
              <button
                key={`nav-item-${item.label}`}
                className={triggerClasses(openMenu === item.slug, isActive)}
                onClick={() => onMenuToggle(item.slug)}
                onMouseEnter={() => onMenuOpen(item.slug)}
                aria-expanded={openMenu === item.slug}
                aria-haspopup="true"
              >
                {item.label}
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={cn(
                    'h-3 w-3 transition-transform duration-200',
                    openMenu === item.slug && 'rotate-180'
                  )}
                  aria-hidden
                />
              </button>
            );
          }

          if ('subMenuType' in item && item.subMenuType === 'dropdown') {
            const isActive = item.subMenu.some((link) =>
              pathname.startsWith(link.href)
            );

            return (
              <div key={`nav-item-${item.label}`} className="relative">
                <button
                  className={triggerClasses(openMenu === item.slug, isActive)}
                  onClick={() => onMenuToggle(item.slug)}
                  onMouseEnter={() => onMenuOpen(item.slug)}
                  aria-expanded={openMenu === item.slug}
                  aria-haspopup="true"
                >
                  {item.label}
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={cn(
                      'h-3 w-3 transition-transform duration-200',
                      openMenu === item.slug && 'rotate-180'
                    )}
                    aria-hidden
                  />
                </button>
                <NavigationDropdownMenu slug={item.slug} links={item.subMenu} />
              </div>
            );
          }

          return (
            <a
              key={`nav-item-${item.label}`}
              href={item.href}
              className={triggerClasses(false, pathname.startsWith(item.href))}
            >
              {item.label}
            </a>
          );
        })}
      </nav>

      {headerButtons.map((button) => (
        <Link
          key={button.label}
          variant={button.variant}
          href={button.href}
          rel={button.target === '_blank' ? 'external noopener noreferrer' : ''}
          target={button.target}
        >
          {button.label}
          <FontAwesomeIcon icon={faAngleRight} />
        </Link>
      ))}
    </div>
  );
};

export default Index;
